import Service from "../Service";
import Vue from "vue";
const resource = "article/";

export default {
    getArticleCategoryURL() {
        return Vue.prototype.$http.defaults.baseURL + "/articlecategory/search";
    },
};